<template>
  <SettingsLayout>
    <Modal :show="modalData.show" @close="modalData.show = false">
      <template #title>
        <div>Warnung</div>
      </template>
      <template #message>
        <!-- {{ modalData.message }} -->
        <p>Die Daten des Nutzers werden unwiderruflich gelöscht.</p>
      </template>
      <template #actions>
        <div class="">
          <div class="flex gap-5 justify-center mt-8">
            <Button
              class="mt-auto"
              @click="
                () => {
                  modalData.show = false;
                }
              "
              >Abbrechen</Button
            >

            <Button
              type="button"
              :disabled="isLoading"
              class="mt-auto"
              @click="deleteUser(modalData.id)"
              >Löschen</Button
            >
          </div>
        </div>
      </template>
    </Modal>

    <Modal :show="modalSave.show" @close="modalSave.show = false">
      <template #title>
        <div>Warnung</div>
      </template>
      <template #message>
        <!-- {{ modalSave.message }} -->
        <p>
          Mit ändern der E-Mail-Adresse verändern Sie den Benutzernamen für den
          Login.
        </p>
      </template>
      <template #actions>
        <div class="">
          <div class="flex gap-5 justify-center mt-8">
            <Button
              class="mt-auto"
              @click="
                () => {
                  modalSave.show = false;
                }
              "
              >Abbrechen</Button
            >

            <Button
              type="button"
              :disabled="isLoading"
              class="mt-auto"
              @click="saveUser(modalSave.id)"
              >Weiter</Button
            >
          </div>
        </div>
      </template>
    </Modal>

    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink
        class="mr-3"
        href="/einstellungen/nutzerverwaltung"
        type="close"
        >Zurück</HeaderLink
      >
      <HeaderButton
        v-if="canDelete && user.data.is_admin == false"
        class="mr-3"
        @click="showDeleteModal()"
        type="close"
        >Löschen</HeaderButton
      >
      <HeaderButton @click="showSaveModal()">Speichern</HeaderButton
      ><!-- @click="submitForm()" -->
    </template>
    <Heading title="Nutzer bearbeiten" />

    <p class="max-w-2xl text-sm text-oteoText"></p>

    <div class="mt-8 mb-6 text-white font-bold flex items-center">
      <Label class="!mb-0" value="Anrede" />
      <input
        v-model="form.salutation"
        class="ml-4 appearance-none"
        id="s_female"
        type="radio"
        value="f"
      />
      <Label
        class="inline ml-2 !mb-0 font-normal"
        for="s_female"
        value="Frau"
      />

      <input
        v-model="form.salutation"
        class="ml-4"
        id="s_male"
        type="radio"
        value="m"
      />
      <Label class="inline ml-2 !mb-0 font-normal" for="s_male" value="Herr" />

      <input
        v-model="form.salutation"
        class="ml-4"
        id="s_none"
        type="radio"
        value="n"
      />
      <Label
        class="inline ml-2 !mb-0 font-normal"
        for="s_none"
        value="Keine Angabe"
      />
    </div>

    <div class="grid grid-cols-2 gap-5 max-w-3xl">
      <div class="">
        <Label for="firstname" value="Vorname" />
        <Input
          id="firstname"
          type="text"
          class="mt-1 block w-full"
          v-model="form.firstname"
          required
          autofocus
          placeholder="Bitte eingeben"
          autocomplete="given-name"
        />
        <div class="mt-2 text-red-600 text-sm" v-if="errors.firstname">
          {{ errors.firstname }}
        </div>
      </div>

      <div class="">
        <Label for="lastname" value="Nachname" />
        <Input
          id="lastname"
          type="text"
          class="mt-1 block w-full"
          v-model="form.lastname"
          required
          placeholder="Bitte eingeben"
          autocomplete="family-name"
        />
        <div class="mt-2 text-red-600 text-sm" v-if="errors.lastname">
          {{ errors.lastname }}
        </div>
      </div>

      <div class="">
        <Label for="email" value="E-Mail" />
        <Input
          id="email"
          type="email"
          class="mt-1 block w-full"
          v-model="form.email"
          required
          autocomplete="email"
          placeholder="Bitte eingeben"
        />
        <div class="mt-2 text-red-600 text-sm" v-if="errors.email">
          {{ errors.email }}
        </div>
      </div>

      <div class="">
        <Label for="tel" value="Telefonnummer" />
        <Input
          id="tel"
          type="tel"
          class="mt-1 block w-full"
          v-model="form.tel"
          required
          autocomplete="tel"
          placeholder="Bitte eingeben"
        />
        <div class="mt-2 text-red-600 text-sm" v-if="errors.tel">
          {{ errors.tel }}
        </div>
      </div>
      <div class="">
        <Label for="role_id" value="Rolle" />
        <Select
          v-if="props.user.data.is_admin"
          class="w-full"
          v-model="form.role_id"
        >
          <option disabled :value="admin_role_id">Administrator</option>
        </Select>

        <Select
          v-if="!props.user.data.is_admin"
          class="w-full"
          v-model="form.role_id"
        >
          <option disabled value="">Bitte wählen</option>

          <option v-for="role in roles" :key="role.id" :value="role.id">
            {{ `${role.name}` }}
          </option>
        </Select>
        <div class="mt-2 text-red-600 text-sm" v-if="errors.role_id">
          {{ errors.role_id }}
        </div>
      </div>

      <div class="">
        <Label for="title" value="Titel" />
        <Select class="w-full" v-model="form.title">
          <option disabled value="" class="">Bitte wählen</option>
          <option value=""></option>
          <option value="Dr.">Dr.</option>
          <option value="Dr. med.">Dr. med.</option>
          <option value="Prof. Dr. med.">Prof. Dr. med.</option>
        </Select>
        <div class="mt-2 text-red-600 text-sm" v-if="errors.title">
          {{ errors.title }}
        </div>
      </div>

      <div class="">
        <Label for="job" value="Tätigkeit" />
        <Select class="w-full" v-model="form.job">
          <option disabled value="" class="">Bitte wählen</option>
          <option value="Zahnarzt/in">Zahnarzt/in</option>
          <option value="Zahnmedizinische Prophylaxe">
            Zahnmedizinische Prophylaxe
          </option>
          <option value="Zahnmedizinische Fachangestellte/r">
            Zahnmedizinische Fachangestellte/r
          </option>
        </Select>
        <div class="mt-2 text-red-600 text-sm" v-if="errors.job">
          {{ errors.job }}
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>

<script setup>
const page_name = "Nutzerverwaltung";

const props = defineProps({
  errors: Object,
  user: Object,
  roles: Array,
  admin_role_id: Number,
});

const canDelete = Inertia.page.props.auth.can["delete settings"];
let saveBtnClicked = false;

//onUnmounted(
//    Inertia.on("before", (e) => {
//        if (form.isDirty && !saveBtnClicked) {
//            return confirm(
//                "Sie haben ungespeicherte Eingaben. Wollen Sie diese Seite wirklich verlassen?"
//            );
//        }
//    })
//);

const modalData = ref({
  show: false,
});
function showDeleteModal() {
  modalData.value.show = true;
}
function deleteUser() {
  Inertia.delete(
    `/users/${props.user.data.id}`,
    {},
    { preserveState: true, replace: true }
  );
  modalData.value.show = false;
}

const modalSave = ref({
  show: false,
});
function showSaveModal() {
  if (form.email !== props.user.data.email) {
    modalSave.value.show = true;
  } else {
    submitForm();
  }
}
function saveUser() {
  submitForm();
}

function submitForm() {
  saveBtnClicked = true;
  form.put("/users/" + props.user.data.id);
}

const form = useForm({
  firstname: props.user.data.firstname,
  lastname: props.user.data.lastname,
  email: props.user.data.email,
  tel: props.user.data.tel,
  role_id: props.user.data.role.id,
  job: props.user.data.job,
  title: props.user.data.title,
  salutation: props.user.data.salutation,
});

import TD from "@/Components/Table/Element.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Textarea from "@/Components/Textarea.vue";
import Select from "@/Components/Select.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import Modal from "@/Components/Settings/Modal.vue";
import Button from "@/Components/Button.vue";
import { ref, onUnmounted } from "vue";
</script>
